import { HttpService } from "./http.service";

const basePath = "/Idiom";
const request = HttpService.handleRequest();

export const IdiomService = {
  getAll
};

async function getAll() {
  return request.get(basePath);
}

export default IdiomService;